module.exports = __webpack_public_path__ + "assets/c80ceb3c3bdab059889f3cdbdc21cfe0.png";